// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XoV3L66N_EYTuMcsdcDS{height:100%;display:flex;position:relative}.XoV3L66N_EYTuMcsdcDS .ATQTedJST3cFNnWfHp3J{display:none}.XoV3L66N_EYTuMcsdcDS .hcsENUs1ybojYgGhdlZK{flex-direction:column;align-items:stretch;width:100%;min-width:0;margin:0 auto;display:flex;position:relative}.XoV3L66N_EYTuMcsdcDS .hcsENUs1ybojYgGhdlZK .CAv57JWwSQCuesGw6YUx{position:absolute;top:24px;left:20px}.XoV3L66N_EYTuMcsdcDS .hcsENUs1ybojYgGhdlZK .z1L5ZUcJFk8UdYT1vdsm{flex-grow:1;width:100%;display:flex}.rfPMEZE1Cgp51L_3tyx0{z-index:var(--zIndex-UI_200);height:100%;position:absolute}.xcynKIPJZooKNqXeyZOS{z-index:var(--zIndex-UI_100);background-color:var(--black-30);position:absolute;top:0;bottom:0;left:0;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `XoV3L66N_EYTuMcsdcDS`,
	"hiddenLeftContent": `ATQTedJST3cFNnWfHp3J`,
	"contentWrapper": `hcsENUs1ybojYgGhdlZK`,
	"collapseIcon": `CAv57JWwSQCuesGw6YUx`,
	"content": `z1L5ZUcJFk8UdYT1vdsm`,
	"mobile": `rfPMEZE1Cgp51L_3tyx0`,
	"overlay": `xcynKIPJZooKNqXeyZOS`
};
export default ___CSS_LOADER_EXPORT___;
